
import dialogActions from './dialogs/dialog-constants';
import { wizardMappedActions } from './wizard/wizard-constants';
export default {
  clearContractingErrorString: 'CLEAR_CONTRACTING_ERROR_STRING',
  showContractingErrorString: 'SHOW_CONTRACTING_ERROR_STRING',
  ...wizardMappedActions,
  ...dialogActions,
};



// WEBPACK FOOTER //
// ./src/app/stores/contracting/root-actions-map.js